const config = {
  version: '2.1.1',
  baseURL: 'https://aem05rrcqj.execute-api.us-west-1.amazonaws.com/prod',
  prodBaseURL: 'https://aem05rrcqj.execute-api.us-west-1.amazonaws.com/prod',
  stagBaseURL: 'https://vt5aqgya9g.execute-api.us-east-1.amazonaws.com/stag',
  googleMapsApiKey: 'AIzaSyCsrDcDlRxzbpeL_J5pjPYykqCiUYMWNCA',
};

export default config;
